export default "__VITE_PUBLIC_ASSET__d3801622__"